import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const PayPeriodSelector = ({ selectedPeriod, onPeriodChange, onRefresh, isRefreshing }) => {
  const payPeriods = [
    { value: '2026-01', label: 'January 2026' },
    { value: '2025-12', label: 'December 2025' },
    { value: '2025-11', label: 'November 2025' },
    { value: '2025-10', label: 'October 2025' },
    { value: '2025-09', label: 'September 2025' },
    { value: '2025-08', label: 'August 2025' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4 md:mb-6">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-1 w-full md:w-auto">
          <Select
            label="Pay Period"
            options={payPeriods}
            value={selectedPeriod}
            onChange={onPeriodChange}
            className="w-full"
          />
        </div>

        <div className="flex items-center gap-2 w-full md:w-auto">
          <Button
            variant="outline"
            size="default"
            onClick={onRefresh}
            loading={isRefreshing}
            iconName="RefreshCw"
            iconPosition="left"
            className="flex-1 md:flex-none"
          >
            Refresh Data
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Download"
            iconPosition="left"
            className="flex-1 md:flex-none"
          >
            Export Report
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PayPeriodSelector;